import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import './ImpersonateBanner.css';

const ImpersonateBanner: React.FC = () => {
  const { isImpersonating, impersonatedUser, logout } = useAuth();

  if (!isImpersonating || !impersonatedUser) return null;

  return (
    <div className="impersonate-banner">
      <span>
        👁 <strong>{impersonatedUser.name}</strong> ({impersonatedUser.role}) 으로 보는 중
      </span>
      <button className="impersonate-banner-btn" onClick={logout}>
        로그아웃하여 복귀
      </button>
    </div>
  );
};

export default ImpersonateBanner;
